import { z } from 'zod';
import { ImageAssetSchema } from '../components/Image';
import { NewsTagSchema } from '../entities/NewsTag';
import { SanityReferenceSchema } from '../sanity';

export const CardContentFieldsSchema = z.object({
  includeInAutomatedCards: z
    .boolean()
    .nullish()
    .transform((x) => x ?? false),
  content: z
    .object({
      headline: z
        .string()
        .nullish()
        .transform((x) => x ?? ''),
      image: ImageAssetSchema.nullish().default(null),
      tags: z.lazy(() =>
        z
          .array(SanityReferenceSchema.or(NewsTagSchema))
          .nullish()
          .transform((x) => (x ? x : []))
      ),
      publicationDate: z
        .string()
        .nullish()
        .transform((x) => x ?? ''),
      summary: z
        .string()
        .nullish()
        .transform((x) => x ?? ''),
      brands: z
        .array(z.string())
        .nullish()
        .transform((x) => (x ? x : []))
    })
    .nullish()
});

export const CardContentLiteFieldsSchema = z.object({
  content: z
    .object({
      image: ImageAssetSchema.nullish().default(null)
    })
    .nullish()
});

export type CardContentFields = z.infer<typeof CardContentFieldsSchema>;
export type CardContent = z.infer<typeof CardContentFieldsSchema>['content'];
